import { render } from "./CallWidget.vue?vue&type=template&id=1d88e016"
import script from "./CallWidget.vue?vue&type=script&lang=js"
export * from "./CallWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__